import { ActionType } from 'typesafe-actions';
import { createDataFetchActions } from '../dataFetching/generators';
import { HEADER_BAR_IDENTIFIER } from './types';

export const fetchHeaderBarBannerData = createDataFetchActions(
    '@HEADER_BAR_BANNER',
    ({ apiService }) => () => apiService.shopApi.getHeaderBarBannerV2(),
    () => HEADER_BAR_IDENTIFIER
);

export const HeaderBarBannerActions = fetchHeaderBarBannerData.actions;

export type HeaderBarBannerActionTypes = ActionType<typeof HeaderBarBannerActions>;
export const getHeaderBarBannerActionsIfNeeded = fetchHeaderBarBannerData.thunk;
